import { mergeObjectUtil } from 'packages/src'

/**
 * @param {ReduxModel} props
 * @returns {ReduxModel}
 */
function createReduxUtil (props) {
  return mergeObjectUtil({
    className: '',
    changed: {},
    data: {},
    validation: null,
    error: null,
    status: null,
    updatedAt: (new Date()).toISOString(),
    createdAt: (new Date()).toISOString(),
    cid: null
  }, props)
}

export default createReduxUtil
